var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restart-wrapper",on:{"click":_vm.openModal}},[_vm._v("\n  "+_vm._s(_vm.text ? _vm.text : _vm.$t('restartBtnText'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }